// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form_formContainer__dcCLA {
  max-width: 100%;
  margin: auto;
  padding: 1.2rem 0;

  & label {
    font-family: Inter;
    font-size: 1.1rem;
    font-weight: 600;
  }

  .form_row_sec__zq46o {
    margin: 1.5rem 0;
  }

  & input {
    height: 50px;
    background-color: #fcfcfc;
  }

  & textarea {
    background-color: #fcfcfc;
  }

  & input::placeholder {
    font-family: inter;
  }
  & textarea::placeholder {
    font-family: inter;
  }
}

.form_submitBtn__ZYsra {
  font-family: inter;
  background-color: var(--primary-color);
  color: var(--text-color);
  border: none;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
}

.form_submitBtn__ZYsra:hover {
  background-color: darkorange;
}

/* -------media-queries-------- */

@media screen and (max-width: 568px) {
  .form_formContainer__dcCLA {
    padding: 0 0;

    & label {
      margin: 1rem 0;
    }
  }

  .form_row_sec__zq46o {
    margin: 0;
  }

  .form_submitBtn__ZYsra {
    width: 100%;
  }
  
}
`, "",{"version":3,"sources":["webpack://./src/Components/FormSection/form.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;;EAEjB;IACE,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,wBAAwB;EACxB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,iCAAiC;;AAEjC;EACE;IACE,YAAY;;IAEZ;MACE,cAAc;IAChB;EACF;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;AAEF","sourcesContent":[".formContainer {\n  max-width: 100%;\n  margin: auto;\n  padding: 1.2rem 0;\n\n  & label {\n    font-family: Inter;\n    font-size: 1.1rem;\n    font-weight: 600;\n  }\n\n  .row_sec {\n    margin: 1.5rem 0;\n  }\n\n  & input {\n    height: 50px;\n    background-color: #fcfcfc;\n  }\n\n  & textarea {\n    background-color: #fcfcfc;\n  }\n\n  & input::placeholder {\n    font-family: inter;\n  }\n  & textarea::placeholder {\n    font-family: inter;\n  }\n}\n\n.submitBtn {\n  font-family: inter;\n  background-color: var(--primary-color);\n  color: var(--text-color);\n  border: none;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.submitBtn:hover {\n  background-color: darkorange;\n}\n\n/* -------media-queries-------- */\n\n@media screen and (max-width: 568px) {\n  .formContainer {\n    padding: 0 0;\n\n    & label {\n      margin: 1rem 0;\n    }\n  }\n\n  .row_sec {\n    margin: 0;\n  }\n\n  .submitBtn {\n    width: 100%;\n  }\n  \n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"formContainer": `form_formContainer__dcCLA`,
	"row_sec": `form_row_sec__zq46o`,
	"submitBtn": `form_submitBtn__ZYsra`
};
export default ___CSS_LOADER_EXPORT___;
